/* rpg-egg.js — quiet gamer easter eggs. No deps. Deferred. ~1KB.
   1) Konami code (↑↑↓↓←→←→ B A) -> unlock the CONSOLE discount, copy it,
      flash a mission-select style toast. For the people who'd try it.
   2) Dev-console art -> a wink for anyone who opens the console.
   Nothing here blocks render, tracks, or fires on a timer. */
(function () {
  'use strict';

  // ---- 1) Konami unlock -------------------------------------------------
  var SEQ = [38, 38, 40, 40, 37, 39, 37, 39, 66, 65];
  var pos = 0;
  var CODE = (window.RPG_EGG_CODE || 'CONSOLE');

  function toast(msg) {
    var el = document.createElement('div');
    el.className = 'rpg-egg-toast';
    el.setAttribute('role', 'status');
    el.textContent = msg;
    document.body.appendChild(el);
    // next frame -> transition in
    requestAnimationFrame(function () { el.classList.add('is-on'); });
    setTimeout(function () {
      el.classList.remove('is-on');
      setTimeout(function () { el.remove(); }, 400);
    }, 3200);
  }

  function unlock() {
    document.body.classList.add('rpg-unlocked');
    try { if (navigator.clipboard) navigator.clipboard.writeText(CODE); } catch (e) {}
    toast('✓ CHEAT ENABLED · CODE "' + CODE + '" COPIED · 15% OFF');
  }

  window.addEventListener('keydown', function (e) {
    // ignore while typing in a field
    var t = e.target;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
    pos = (e.keyCode === SEQ[pos]) ? pos + 1 : (e.keyCode === SEQ[0] ? 1 : 0);
    if (pos === SEQ.length) { pos = 0; unlock(); }
  }, { passive: true });

  // ---- 2) Console wink --------------------------------------------------
  try {
    console.log(
      '%cRPG COUNTRY',
      'font:700 22px Inter,system-ui;letter-spacing:.35em;color:#000;background:#fff;padding:6px 12px;'
    );
    console.log(
      '%c// you found the dev console. gg.\n// try ↑↑↓↓←→←→ b a',
      'font:12px ui-monospace,monospace;color:#1d3686;'
    );
  } catch (e) {}
})();
